import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog } from 'components/Ui';
import { selectServiceLocationIsShowSkipDialog } from 'containers/PrimoAccount/selectors';
import { hideSkipDialog } from 'containers/PrimoAccount/actions';
import SkipDelivery from './index';

const Modal = ({ size = 'small', title = '' }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const isShowSkipDialog = useSelector(selectServiceLocationIsShowSkipDialog());

  const handelHideSkip = () => dispatch(hideSkipDialog());

  return (
    <Dialog
      onClose={handelHideSkip}
      open={isShowSkipDialog}
      size={size}
      fullScreen={isMobile}
      title={title}
    >
      <SkipDelivery onClose={handelHideSkip} />
    </Dialog>
  );
};

Modal.propTypes = {
  size: PropTypes.string,
  title: PropTypes.string,
};

export default Modal;
